import classNames from 'classnames';
import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
}

export const Select: React.FC<SelectProps> = ({
  className,
  error,
  ...props
}) => {
  return (
    <select
      {...props}
      className={classNames(
        'bg-app-panel-dark',
        'border-app-panel border',
        'rounded-md',
        'px-3 py-2',
        'text-sm',
        'focus:ring-primary-500 focus:outline-none focus:ring-2',
        error && 'border-red-500',
        className,
      )}
    />
  );
};
